import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useBusinessMembers = (): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  return useQuery(ReactQueryKeys.BusinessMembers, async () => {
    const response = await treasureApi().get(`/users/getAll`);

    return response.data.users;
  });
};
